module.exports = __webpack_public_path__ + "img/wow.0370fdab.png";